'use client';

import React, { PropsWithChildren, useEffect } from 'react';
import { useAppSelector } from '@/hooks';
import { useCurrentHospital } from '@/modules/appContext';
import { SplashScreenLoader } from '@/components/loader';
import { selectUserAuthenticated } from './authenticatedLayout';
import { EmptyLayout } from './EmptyLayout';

/**
 * Chrome-less frame for authenticated pages that live in their own tab (e.g. the Stripe onboarding
 * round-trip). Without the app bar, nothing would publish the JWT's hospital id into the store —
 * `ActiveHospitalSelect` normally does it — and `withProtectedAccess` would show its splash screen
 * forever, so the same bootstrap is done here, reading the id straight off the JWT rather than
 * waiting on a doctor-hospitals round trip. Gated on the same user-authenticated check as
 * `AuthenticatedLayout` so a locked-but-enabled user can't mount these pages.
 */
export const StandaloneAuthenticatedLayout = ({
  children
}: PropsWithChildren) => {
  const isUserAuthenticated = useAppSelector(selectUserAuthenticated);
  const { refresh } = useCurrentHospital({ skip: true });

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <EmptyLayout bgcolor="background.default">
      {isUserAuthenticated ? children : <SplashScreenLoader />}
    </EmptyLayout>
  );
};
